export class GitAdapterError extends Error {
    code;
    cause;
    constructor(message, code, cause) {
        super(message);
        this.name = "GitAdapterError";
        this.code = code;
        this.cause = cause;
    }
}
//# sourceMappingURL=errors.js.map